var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "lib-cards" }, [
      _c(
        "div",
        [
          _c("h2", [_vm._v("AHAs")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Create AHAs in minutes using our AHA library with 1,000’s of completed AHAs."
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "see-library" }, [
            _c(
              "a",
              {
                staticClass: "lib-arrow-link",
                attrs: { href: "javascript:void(0)" },
                on: { click: _vm.showAhaInfo },
              },
              [_vm._v("See our AHA Library")]
            ),
          ]),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "options" },
            [
              _c("label", [_vm._v("Select your annual AHA needs:")]),
              _vm._v(" "),
              _c("lib-radio-select", {
                attrs: {
                  name: "ahas-radio-select",
                  options: _vm.onlyAhasOptions,
                  value: _vm.value.ahas,
                },
                on: {
                  input: function ($event) {
                    return _vm.$emit(
                      "input",
                      Object.assign({}, _vm.value, { ahas: $event })
                    )
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "spacer" }),
          _vm._v(" "),
          _c("lib-pricing-widget", {
            attrs: { yearly: _vm.ahasYearly, "one-time": _vm.ahasOneTime },
          }),
          _vm._v(" "),
          _vm._t("default", null, {
            canPurchase: !!_vm.ahasYearly || !!_vm.ahasOneTime,
            cart: _vm.ahasCart,
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("h2", [_vm._v("Plans")]),
          _vm._v(" "),
          _c("p", [
            _vm._v("Complete, fully editable administrative and safety plans."),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "see-library" }, [
            _c(
              "a",
              {
                staticClass: "lib-arrow-link",
                attrs: { href: "javascript:void(0)" },
                on: { click: _vm.showPlanInfo },
              },
              [_vm._v("See our Plan Library")]
            ),
          ]),
          _vm._v(" "),
          _c("ul", [
            _c("li", [
              _c("i", { staticClass: "fa-solid fa-check" }),
              _vm._v(
                " Library of 27 of customizable Plans, including: APP, QCP, EPP, & "
              ),
              _c(
                "a",
                {
                  attrs: { href: "javascript:void(0)" },
                  on: { click: _vm.showPlanInfo },
                },
                [_vm._v("More")]
              ),
            ]),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _vm._m(2),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "options" },
            [
              _c("label", [_vm._v("Select your annual Plan needs:")]),
              _vm._v(" "),
              _c("lib-radio-select", {
                attrs: {
                  name: "plans-radio-select",
                  options: _vm.plansOptions,
                  value: _vm.value.plans,
                },
                on: {
                  input: function ($event) {
                    return _vm.$emit(
                      "input",
                      Object.assign({}, _vm.value, { plans: $event })
                    )
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "spacer" }),
          _vm._v(" "),
          _c("lib-pricing-widget", { attrs: { yearly: _vm.plansYearly } }),
          _vm._v(" "),
          _vm._t("default", null, {
            canPurchase: !!_vm.plansYearly,
            cart: _vm.plansCart,
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("h2", [_vm._v("Combo Discount")]),
          _vm._v(" "),
          _c("div", { staticClass: "badge" }, [_vm._v("Best Value")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Combine AHAs and Plans together and get a discounted rate."
            ),
          ]),
          _vm._v(" "),
          _vm._m(3),
          _vm._v(" "),
          _c("div", { staticClass: "spacer" }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "options" },
            [
              _c("label", [_vm._v("Select your annual AHA needs:")]),
              _vm._v(" "),
              _c("lib-radio-select", {
                attrs: {
                  name: "ahas-combos-radio-select",
                  options: _vm.ahasOptions,
                  value: _vm.value.comboAhas,
                },
                on: {
                  input: function ($event) {
                    return _vm.$emit(
                      "input",
                      Object.assign({}, _vm.value, { comboAhas: $event })
                    )
                  },
                },
              }),
              _vm._v(" "),
              _c("label", [_vm._v("Select your annual Plan needs:")]),
              _vm._v(" "),
              _c("lib-radio-select", {
                attrs: {
                  name: "plans-combos-radio-select",
                  options: _vm.plansOptions,
                  value: _vm.value.comboPlans,
                },
                on: {
                  input: function ($event) {
                    return _vm.$emit(
                      "input",
                      Object.assign({}, _vm.value, { comboPlans: $event })
                    )
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("lib-pricing-widget", {
            attrs: {
              yearly: _vm.comboYearly,
              "combo-discount": _vm.comboTotalDiscount,
            },
          }),
          _vm._v(" "),
          _vm._t("default", null, {
            canPurchase: !!_vm.comboYearly,
            cart: _vm.comboCart,
          }),
        ],
        2
      ),
    ]),
    _vm._v(" "),
    _vm._m(4),
    _vm._v(" "),
    _vm.ahaInfo
      ? _c(
          "div",
          { staticClass: "info-wrapper", on: { click: _vm.hideAhaInfo } },
          [
            _c(
              "div",
              {
                staticClass: "info-popup aha-info",
                on: {
                  click: [
                    function ($event) {
                      $event.stopPropagation()
                    },
                    _vm.closeDivisions,
                  ],
                },
              },
              [
                _c("i", {
                  staticClass: "fa fa-times",
                  on: { click: _vm.hideAhaInfo },
                }),
                _vm._v(" "),
                _vm._m(5),
                _vm._v(" "),
                _c("div", { staticClass: "info-main" }, [
                  _c("div", { staticClass: "features-box" }, [
                    _c("div", { staticClass: "label" }, [
                      _c("div", [
                        _vm._v(
                          "CURRENT LIST OF PRE-WRITTEN AHAS AVAILABLE WITH A SUBSCRIPTION:"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.filterText,
                            expression: "filterText",
                          },
                        ],
                        attrs: {
                          type: "text",
                          id: "ahaFilter",
                          placeholder: "Search here...",
                        },
                        domProps: { value: _vm.filterText },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                          },
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.filterText = $event.target.value
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "features" }, [
                      _c(
                        "ul",
                        {
                          staticClass: "aha-division-list",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                            },
                          },
                        },
                        _vm._l(_vm.divisions, function (division) {
                          return !_vm.filterText ||
                            division.ahas.some(function (aha) {
                              return _vm.ahaFiltering(aha, _vm.filterText)
                            })
                            ? _c(
                                "li",
                                {
                                  staticClass: "aha-division",
                                  class: { shown: division.shown },
                                  on: {
                                    click: function ($event) {
                                      division.shown = !division.shown
                                    },
                                  },
                                },
                                [
                                  _c("div", { staticClass: "division-box" }, [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(division.code) +
                                        " " +
                                        _vm._s(division.title) +
                                        "\n                                    "
                                    ),
                                    !division.shown
                                      ? _c(
                                          "span",
                                          { staticClass: "collapsable-icon" },
                                          [_vm._v("+")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    division.shown
                                      ? _c(
                                          "span",
                                          { staticClass: "collapsable-icon" },
                                          [_vm._v("−")]
                                        )
                                      : _vm._e(),
                                  ]),
                                  _vm._v(" "),
                                  division.shown ||
                                  (_vm.filterText && _vm.filterText.length > 3)
                                    ? _c(
                                        "ul",
                                        {
                                          staticClass: "individual-aha-list",
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                            },
                                          },
                                        },
                                        _vm._l(division.ahas, function (aha) {
                                          return !_vm.filterText ||
                                            _vm.ahaFiltering(
                                              aha,
                                              _vm.filterText
                                            )
                                            ? _c("li", [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(aha.code) +
                                                    " " +
                                                    _vm._s(aha.title) +
                                                    "\n                                    "
                                                ),
                                              ])
                                            : _vm._e()
                                        }),
                                        0
                                      )
                                    : _vm._e(),
                                ]
                              )
                            : _vm._e()
                        }),
                        0
                      ),
                    ]),
                    _vm._v(" "),
                    _vm._m(6),
                  ]),
                ]),
              ]
            ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.planInfo
      ? _c(
          "div",
          { staticClass: "info-wrapper", on: { click: _vm.hidePlanInfo } },
          [
            _c(
              "div",
              {
                staticClass: "info-popup",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                  },
                },
              },
              [
                _c("i", {
                  staticClass: "fa fa-times",
                  on: { click: _vm.hidePlanInfo },
                }),
                _vm._v(" "),
                _vm._m(7),
                _vm._v(" "),
                _vm._m(8),
              ]
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", [
      _c("li", [
        _c("i", { staticClass: "fa-solid fa-check" }),
        _vm._v(" Library of 1,000s of completed & customizable AHAs"),
      ]),
      _vm._v(" "),
      _c("li", [
        _c("i", { staticClass: "fa-solid fa-check" }),
        _vm._v(
          " Checklist of AHA Steps, Tools & Equipment - Just point & click"
        ),
      ]),
      _vm._v(" "),
      _c("li", [
        _c("i", { staticClass: "fa-solid fa-check" }),
        _vm._v(" "),
        _c("a", { attrs: { href: "/activity-hazard-analysis" } }, [
          _vm._v("AHA Builder"),
        ]),
        _vm._v(", customize your AHAs step by step"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("i", { staticClass: "fa-solid fa-check" }),
      _vm._v(
        " Automated information input- Team info, Maps, Safety info, & More"
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("i", { staticClass: "fa-solid fa-check" }),
      _vm._v(" Access to our "),
      _c("a", { attrs: { href: "/documents" } }, [_vm._v("Plan Builder")]),
      _vm._v(", customize your Plans step by step"),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", [
      _c("li", [
        _c("i", { staticClass: "fa-solid fa-check" }),
        _vm._v(
          " Everything you get when you purchase both AHAs and Plans at a discounted rate"
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "contact-us" }, [
      _vm._v(
        "\n        Don’t see what you need? Contact us for custom pricing. "
      ),
      _c(
        "a",
        { staticClass: "lib-arrow-link", attrs: { href: "/contact-us" } },
        [_vm._v("CONTACT US")]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header" }, [
      _c("div", { staticClass: "title" }, [_vm._v("Activity Hazard Analysis")]),
      _vm._v(" "),
      _c("div", { staticClass: "detail" }, [
        _vm._v(
          "Complete with automatic translation into more than 40 languages."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "footer" }, [
      _vm._v("Still not sure?\n                        "),
      _c(
        "a",
        {
          staticClass: "link",
          attrs: { href: "/webinar-signup", target: "_blank" },
        },
        [_vm._v("Contact us for a free webinar!")]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header" }, [
      _c("div", { staticClass: "title" }, [_vm._v("Safety & Admin Plans")]),
      _vm._v(" "),
      _c("div", { staticClass: "detail" }, [
        _vm._v("Complete, fully-editable administrative and safety plans."),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "info-main" }, [
      _c("div", { staticClass: "features-box" }, [
        _c("div", { staticClass: "label" }, [_vm._v("INCLUDES:")]),
        _vm._v(" "),
        _c("div", { staticClass: "features" }, [
          _c("div", { staticClass: "features-column" }, [
            _c("ul", [
              _c("li", { staticClass: "feature" }, [
                _vm._v("Accident Prevention Plan"),
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "feature" }, [
                _vm._v("Assured Equipment Grounding Conductor Program"),
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "feature" }, [
                _vm._v("Blood Borne Pathogen Program"),
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "feature" }, [
                _vm._v("Confined Space Plan"),
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "feature" }, [
                _vm._v("Covid-19 Exposure Prevention Plan"),
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "feature" }, [
                _vm._v("Crane Safety Plan"),
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "feature" }, [
                _vm._v("Crystalline Sillica Exposure Control Plan"),
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "feature" }, [_vm._v("Demolition Plan")]),
              _vm._v(" "),
              _c("li", { staticClass: "feature" }, [
                _vm._v("Drug Free Workplace Program"),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "features-column" }, [
            _c("ul", [
              _c("li", { staticClass: "feature" }, [
                _vm._v("Electrical & Arc Flash Safety Program"),
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "feature" }, [
                _vm._v("Environmental Protection Plan"),
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "feature" }, [
                _vm._v("Excavation & Trenching Plan"),
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "feature" }, [
                _vm._v("Fall Protection Plan"),
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "feature" }, [
                _vm._v("Fall Rescue Plan"),
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "feature" }, [
                _vm._v("Fatigue Management Plan"),
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "feature" }, [
                _vm._v("Fertilizer & Pesticide Treatment Plan"),
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "feature" }, [
                _vm._v("Fire Prevention Plan"),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "features-column" }, [
            _c("ul", [
              _c("li", { staticClass: "feature" }, [
                _vm._v("Hazard Communication Plan"),
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "feature" }, [
                _vm._v("Hazardous Energy Control Plan"),
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "feature" }, [
                _vm._v("Health and Safety Plan"),
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "feature" }, [
                _vm._v("Heat & Cold Stress Management "),
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "feature" }, [
                _vm._v("Hearing Conservation Program"),
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "feature" }, [
                _vm._v("Lead Awareness Proection Program"),
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "feature" }, [
                _vm._v("Quality Control Plan"),
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "feature" }, [
                _vm._v("Waste Management Plan"),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "footer" }, [
          _vm._v("Don’t see the document you need?\n                        "),
          _c(
            "a",
            {
              staticClass: "link",
              attrs: { href: "/contact-us", target: "_blank" },
            },
            [_vm._v("Contact Us!")]
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }